export const FORM_ENTRY_NOTIFICATION = 'FORM_ENTRY_SUBMITTED';

export const formEntryPreferences = settings =>
    Array.isArray(settings?.[FORM_ENTRY_NOTIFICATION]) ? settings[FORM_ENTRY_NOTIFICATION] : ['Push'];

export const toggleFormEntryPreference = (settings, channel) =>
    formEntryPreferences(settings).includes(channel) ? [] : [channel];

export const formEntryLoginRedirect = (pathname, requestedFile) =>
    pathname?.startsWith('/forms/entries/') && typeof requestedFile === 'string'
        ? `${pathname}?file=${encodeURIComponent(requestedFile)}`
        : pathname;

export const findEntryUpload = (payload, path) => {
    if (!path || !payload || typeof payload !== 'object') return null;
    if (payload.path === path && typeof payload.filename === 'string') return payload;
    for (const value of Object.values(payload)) {
        if (value && typeof value === 'object') {
            const file = findEntryUpload(value, path);
            if (file) return file;
        }
    }
    return null;
};
